import toast from 'react-hot-toast'
import * as React from 'react'

export function toastMultilineErrors(messageArray: string[]) {
  toast.error(
    React.createElement('ul', { className: 'm-0' },
      messageArray?.map((msg, i) =>
        React.createElement('li', { className: 'list-disc', key: i }, msg)
      )
    )
  )
}
